<ul class="">
    <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: list }"></ng-container>
</ul>

<ng-template #recursiveListTmpl let-list="list">
    <ng-container *ngFor="let item of list | orderBy: 'translations'; index as i; trackBy: utilsService.trackByItems">
        <li>
            <div class="item-container" [ngClass]="{ 'item-container--is-father': item[childElement].length > 0, 'item-container--is-father-first': !item.parentId, 'item-container--is-child': !(item[childElement].length > 0) }" (click)="toggleItem(item, item[childElement].length > 0)">
                    <img class="pointer" width="24" [hidden]="!item['checked'] || item[childElement].length > 0" height="24" [alt]="'checked'" src="assets/img/checkbox_checked.svg">
                    <img class="pointer" width="24" [hidden]="item['checked'] || item[childElement].length > 0" height="24" [alt]="'unchecked'" src="assets/img/checkbox_unchecked.svg">
                    <div class="item"><span *ngIf="item[childElement].length > 0">{{ i + 1 }}.</span> {{utilsService._api(item['translations'], 'name')}}</div>
                    <img class="pointer" width="24" [hidden]="!item['opened'] || !(item[childElement].length > 0)" height="24" [alt]="'arrowUp'" src="assets/img/keyboard_arrow_up.svg">
                    <img class="pointer" width="24" [hidden]="item['opened'] || !(item[childElement].length > 0)" height="24" [alt]="'arrowDown'" src="assets/img/keyboard_arrow_down.svg">
            </div>
        </li>
        <ng-container *ngIf="item['hidden']">
            <ul class="" *ngIf="item[childElement].length > 0">
                <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: item[childElement] }">
                </ng-container>
            </ul>
        </ng-container>
    </ng-container>
</ng-template>